import React from "react";
import { truncateName } from "../utils/customFunction";
import {
  getGridItemStyles,
  getListItemStyles,
  getItemNameStyles,
  getListItemNameStyles,
} from "../styles/styles";
import { DirectoryProps } from "../types/types";
import { useTheme } from "../contexts/ThemeContext";

export const Directory: React.FC<DirectoryProps> = ({
  name,
  icon,
  handleChangeDirectory,
  id,
  isSelected = false,
  viewMode = "grid",
  onContextMenu,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
}) => {
  const { theme } = useTheme();

  if (viewMode === "list") {
    return (
      <div
        style={getListItemStyles(theme, isSelected)}
        onClick={() => handleChangeDirectory(id)}
        onContextMenu={onContextMenu}
        draggable
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onDragEnd={onDragEnd}
      >
        <img src={icon} alt="Folder" style={{ width: "24px", height: "24px" }} />
        <span style={getListItemNameStyles(theme)}>{name}</span>
      </div>
    );
  }

  return (
    <div
      style={getGridItemStyles(theme, isSelected)}
      onClick={() => handleChangeDirectory(id)}
      onContextMenu={onContextMenu}
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <img src={icon} alt="Folder" />
      <span style={getItemNameStyles(theme)}>{truncateName(name)}</span>
    </div>
  );
};
